module.exports = __webpack_public_path__ + "img/abacus.51f65051.svg";